/* eslint-disable */
import { createApp } from 'vue'
import App from './App.vue';
import router from './router';
export const BACKEND_URL = '/bill-aiss/backend';
export const APP_BASE = '/bill-aiss';
// const BACKEND_URL = 'http://localhost:8083/billel-photo-backend';

createApp(App).use(router).mount('#app');
